export default __webpack_public_path__ + "static/media/Boelter.4fc2a4e5.webp";